import debug from "debug";
const STORE_DEBUG_NAMESPACE = "desjti:store";
const STORE_SETUP_NAMESPACE = `${STORE_DEBUG_NAMESPACE}:setup`;
/**
 * @example
 * StoreLogger.mainLogger('This is a debug message'); will output "desjti:store This is a debug message"
 * StoreLogger.setupLogger('This is a debug message for store setup'); will output "desjti:store:setup This is a debug message for store setup"
 */
export class StoreLogger {
}
StoreLogger.mainLogger = debug(STORE_DEBUG_NAMESPACE);
StoreLogger.setupLogger = debug(STORE_SETUP_NAMESPACE);
//# sourceMappingURL=StoreLogger.js.map